module.exports = __webpack_public_path__ + "static/media/portfolio1 (57).3cecb562.jpeg";